import { createContext } from 'react'

export type OpenSnackbarType = (props: {
  message: string
  type?: 'success' | 'alert' | 'neutral' | 'warning'
  autoHideDuration?: number
  timeoutInMs?: number
}) => void

export type SnackbarContextType = OpenSnackbarType | (() => void)
export const snackbarContext = createContext<SnackbarContextType>(() => {})

export const makeAllRelativeLinksStartWithSlash = (data: string): string => {
  if (!data) return ''
  return data.replace(/(\[.*?\])\(([^)]+)\)/g, (match, text, url) => {
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('/')) {
      return `${text}(${url})`
    }
    return `${text}(/${url})`
  })
}

export const convertIsoDateToTimestamp = (isoDate: string): number => {
  const date = new Date(isoDate)
  return date.getTime()
}
